import { queryOptions, useQuery } from "@tanstack/react-query";
import type { GetV1LinksByProfileLinkResponse } from "../../client";
import {
  getV1JobsOptions,
  getV1LinksByProfileLinkOptions,
} from "../../client/@tanstack/react-query.gen";
import { jsonParse } from "../utils/parse";
import type { QueryConfig } from "../utils/query-config";

export const useGetBackgroundJob = (
  profileId: string,
  type: string,
  opts?: { refetchInterval?: number | false },
) =>
  useQuery({
    ...getV1JobsOptions({ query: { profileID: profileId, type } }),
    enabled: Boolean(profileId && type),
    staleTime: 0,
    ...opts,
  });
